import {getTimezoneOffset} from "./getTimezoneOffset";

export function setTimezoneInput(timezoneHiddenInput)
{
    timezoneHiddenInput.value = getTimezoneOffset();
}